import { API_BASE_URL } from './core'

export type ResendAuthInviteResult = {
  ok: boolean
  rateLimited?: boolean
}

/**
 * Unauthenticated. Do not use fetchWithAuth (that 401s with no session).
 */
export async function resendAuthInvite(email: string): Promise<ResendAuthInviteResult> {
  const response = await fetch(`${API_BASE_URL}/api/auth/resend-invite`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  })
  if (response.status === 429) {
    return { ok: false, rateLimited: true }
  }
  if (!response.ok) {
    return { ok: false }
  }
  return { ok: true }
}
